import { render, staticRenderFns } from "./Turno.vue?vue&type=template&id=6cc6e7a8&scoped=true"
import script from "./Turno.vue?vue&type=script&lang=js"
export * from "./Turno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc6e7a8",
  null
  
)

export default component.exports